import React from "react";
import certificate1 from "../../assetsCon/assets/img/certificate/blank_certificate.jpg";
import certificate2 from "../../assetsCon/assets/img/certificate/certi2.png";
import certificate3 from "../../assetsCon/assets/img/certificate/certi3.png";
import signature from "../../assetsCon/assets/img/certificate/signature/signature.png";
import { useState } from "react";

const Certificate = () => {
  const [certificates, setCertificates] = useState([certificate1, certificate2, certificate3]);
  const [data, setData] = useState({
    date: "20-11-11",
    cName: "Nikhil Khambhatyta",
    cNumber: 70854,
    compatition: "Rakhi Macking Comapatition",
  });
  return (
    <>
      <div className="h-20 flex bg-gray-200 px-2 rounded m-2 relative">
        {certificates.map((certificate) => (
          <div className="m-2 relative">
            <input type="radio" id="radio1" name="myRadio" className="absolute top-0 left-0 opacity-0 cursor-pointer" />
            <label htmlFor="radio1">
              <img src={certificate} alt="" className="rounded h-16" />
            </label>
          </div>
        ))}
      </div>

      <div className="">
        <article className="h-screen bg-cover bg-center relative" style={{ backgroundImage: `url(${certificate1})` }}>
          <p className="text-6xl text-gray  font-serif font-semibold absolute top-[37%] left-[50%] transform -translate-x-1/2 -translate-y-1/2">{data.cName}</p>
          <p className="text-4xl text-gray absolute top-[57%] left-[50%] transform -translate-x-1/2 -translate-y-1/2">{data.compatition}</p>
          <p className="text-3xl text-gray absolute top-[74%] left-[28%] transform -translate-x-1/2 -translate-y-1/2">{data.date}</p>
          <img src={signature} alt="Signature" className="text-3xl h-32 absolute top-[73%] left-[72%] transform -translate-x-1/2 -translate-y-1/2" />
          <p className="text-md text-gray absolute top-[93%] left-[14%] transform -translate-x-1/2 -translate-y-1/2">Certificate No. : {data.cNumber}</p>
        </article>
      </div>
    </>
  );
};

export default Certificate;
